import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

/** Creates custom http parameters */
export class CustomHttpParams extends HttpParams {
  constructor(public spec: string) {
    super();
  }
}

/** Handles the Api calls, data is passed to the api in {params:{key: value}} format*/
@Injectable({
  providedIn: 'root',
})

export class ApiHandlerService extends HttpClient {
  constructor(
    public router: Router,
    private httpHandler: HttpHandler,
  ) {
    super(httpHandler);
  }

  /** This method returns the custom http params to defind the api request */
  getTypeParams(options: any) {
    return (options !== undefined && options.type !== undefined) ?
      new CustomHttpParams(options.type) : new CustomHttpParams('asi');
  }
  /** This method gets a request to the passed url, body and options */
  getRequest(api: string, options: any): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    return super.get(`${environment.svpp_gateway}${api}`, {
      headers: headers,
      params: this.getTypeParams(options)
    }).pipe(
      map((res: any) => {
        return (res);
      }),
      catchError(this.handleError.bind(this))
    );
  }

  /** This method post a request to the passed url, body and options */
  postRequest(api: string, body: any | null, options: any): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    return super.post(`${environment.svpp_gateway}${api}`, Object.assign(body), {
      headers: headers,
      params: this.getTypeParams(options)
    }).pipe(
      map((res: any) => {
        return (res);
      }),
      catchError(this.handleError.bind(this))
    );
  }
  /**
   *@method putRequest called when requested to approve or reject the files
   * @arg string api
   * @arg (any | null) body
   * @arg * [options]
   * @returns Observable<any>
   */
  putRequest(api: string, body: any | null, options?: any): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    return super.put(`${environment.svpp_gateway}${api}`, Object.assign(body), {
      headers: headers,
      params: this.getTypeParams(options)
    });
  }
  /** This method adds the custom headers taken from the user input to the http request */
  getHeaders(data: { type: string, params: any }): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    if (data !== undefined) {
      if (data.type === 'getasi' && data.params !== undefined) {
        headers = (!!data.params.review && data.params.review === 'submitted') ?
          headers.set('review-status', data.params.review) : headers;
      } else if (data.type === 'getpackage' && data.params !== undefined) {
        headers = (!!data.params.review && data.params.review === 'submitted') ?
          headers.set('review-status', data.params.review) : headers;
      } else if (data.type === 'getCapability' && data.params !== undefined) {
        headers = (!!data.params.generation) ?
          headers.set('generation', data.params.generation) : headers;
      } else if (data.type === 'getproductids' && data.params !== undefined) {
        headers = (!!data.params.generation) ?
          headers.set('generation', data.params.generation) : headers;
      }
    }
    return headers;
  }

  /** This method handles the errors of a http request*/
  handleError(err: HttpErrorResponse): Observable<any> {
    if (err.error['error'] !== 'Inactive user') {
      const errorCode = err.error && err.error.status && err.error.status.messages && err.error.status.messages.length &&
        err.error.status.messages.map(error => error.responseCode);
      if (this.isAuthenticationError(err, errorCode[0])) {
        this.routeError();
        return throwError(() => ({ errorCode: 'UNAUTHORIZED' }));
      }
      const throwObj = (!!errorCode && errorCode.length) ? errorCode : [err.status];
      const errorMessage = err.error && err.error.status && err.error.status.messages && err.error.status.messages.length &&
        err.error.status.messages.map(error => error.detailedDescription);
      const url = err.url;
      // Extract API path by removing the gateway domain prefix
      const apiPath = url ? url.substring(url.indexOf('/v')) : '';
      const errorResponse = { 'success': false, errorCode: throwObj[0], errorMessage: errorMessage[0], api: apiPath };
      return throwError(() => errorResponse);
    } else { return throwError(() => err.error); }
  }

  /** This method determines if it is an authentication error from the api gateway*/
  isAuthenticationError(err: HttpErrorResponse, errorCode: string): boolean {
    return (err.status === 0 && err.ok === false && err.statusText === 'Unknown Error') || (!!errorCode && errorCode === 'APIGW-403');
  }
  /*
  * @function routeError routes to error page
  * @returns void
  **/
  private routeError(): void {
    this.router.navigate(['dashboard/error'], { queryParams: {}, skipLocationChange: false });
  }
}

